import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Award, CheckCircle, Scale } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const AboutPage = () => {
  const values = [
    {
      icon: CheckCircle,
      title: 'Dürüstlük',
      description: 'Mesleki faaliyetlerimizde şeffaflık ve dürüstlük ilkesiyle hareket ederiz.',
    },
    {
      icon: Scale,
      title: 'Adalet',
      description: 'Her dosyada adil ve etkin hukuki süreç yürütülmesini sağlarız.',
    },
    {
      icon: Award,
      title: 'Özen',
      description: 'Her müvekkilimize özel ilgi ve özen göstererek çalışırız.',
    },
  ];

  return (
    <div 
      className="min-h-screen relative"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_avukat-portal-6/artifacts/rf25a184_indir.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Navbar />

      {/* Hero Section with black semi-transparent blur background */}
      <section className="relative h-96 flex items-center justify-center pt-20">
        <div className="backdrop-blur-md bg-black/60 px-12 py-8 rounded-lg">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white uppercase">
              HAKKINDA
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section with black semi-transparent blur background */}
      <section className="relative py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="backdrop-blur-md bg-black/60 p-12 rounded-lg">
            <div className="space-y-8 text-gray-300 text-lg leading-relaxed text-center">
              <p>
                İzmir Barosu'na kayıtlı Avukat Zeynep Gür, hukuk eğitiminin ardından mesleki stajını tamamlamış ve halen
                kendi bürosunda avukatlık faaliyetlerini sürdürmektedir. Mesleki çalışmalarında dürüstlük, özen, gizlilik
                ve müvekkil odaklılık ilkelerini esas almakta; bireyler ve kurumlara hukukun farklı alanlarında danışmanlık
                ve temsil hizmeti sunmaktadır.
              </p>
              <p>
                Aile hukuku, ceza hukuku, ticaret hukuku, iş hukuku, miras hukuku ve gayrimenkul hukuku başta olmak üzere
                çeşitli alanlarda hukuki süreçlerde görev almakta; güncel mevzuat ve yargı kararlarını yakından takip ederek
                müvekkillerine etkin çözümler üretmektedir.
              </p>
              <p>
                Avukat Zeynep Gür, her bir dosyaya özel ilgi ve özen göstermeyi, hukuki sürecin adil ve etkin şekilde
                yürütülmesini sağlamak için çalışmayı temel mesleki anlayış edinmiştir.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section with black semi-transparent blur background */}
      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="backdrop-blur-md bg-black/60 p-12 rounded-lg">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-12 text-center uppercase">
              DEĞERLERİMİZ
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {values.map((value, index) => {
                const IconComponent = value.icon;
                return (
                  <Card key={index} className="bg-white/10 backdrop-blur-md border-white/20">
                    <CardContent className="p-8 text-center">
                      <div className="w-16 h-16 mx-auto rounded-full bg-white/20 flex items-center justify-center mb-4">
                        <IconComponent className="w-8 h-8 text-white" />
                      </div>
                      <h3 className="text-white font-bold text-xl mb-3">{value.title}</h3>
                      <p className="text-gray-300">{value.description}</p>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;